var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path2, _path3, _circle, _path4, _rect10, _rect11, _rect12, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOpportunitiesPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65.8228,
    y: 128.887,
    width: 283.544,
    height: 214.346,
    rx: 12,
    fill: "#FFFDEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.0124 288.598C84.4282 289.185 84.4308 290.135 85.0181 290.719C85.6054 291.303 86.5552 291.301 87.1394 290.714L85.0124 288.598ZM102.497 273.147V271.647H101.874L101.434 272.089L102.497 273.147ZM114.321 273.147V274.647H114.945L115.384 274.204L114.321 273.147ZM126.144 261.26V259.76H125.521L125.081 260.202L126.144 261.26ZM135.34 261.26V262.76H136.081L136.531 262.172L135.34 261.26ZM147.266 245.702L148.513 244.868L147.349 243.128L146.076 244.789L147.266 245.702ZM157.674 261.26L156.427 262.094L156.872 262.76H157.674V261.26ZM174.752 261.26V262.76H175.798L176.159 261.778L174.752 261.26ZM187.889 225.6V224.1H186.843L186.482 225.081L187.889 225.6ZM207.595 225.6V227.1H208.678L209.019 226.072L207.595 225.6ZM220.075 187.959V186.459H218.992L218.651 187.487L220.075 187.959ZM236.497 187.959L237.955 187.609L237.68 186.459H236.497V187.959ZM245.516 225.6L244.057 225.949L244.333 227.1H245.516V225.6ZM259.487 225.6V227.1H260.277L260.724 226.449L259.487 225.6ZM272.624 206.449V204.949H271.834L271.387 205.601L272.624 206.449ZM285.104 206.449L286.523 205.963L286.176 204.949H285.104V206.449ZM291.673 225.6L290.254 226.087L290.602 227.1H291.673V225.6ZM304.81 225.6V227.1H305.407L305.841 226.69L304.81 225.6ZM315.977 215.034V213.534H315.38L314.946 213.945L315.977 215.034ZM329.114 216.534C329.942 216.534 330.614 215.863 330.614 215.034C330.614 214.206 329.942 213.534 329.114 213.534V216.534ZM87.1394 290.714L103.561 274.204L101.434 272.089L85.0124 288.598L87.1394 290.714ZM102.497 274.647H114.321V271.647H102.497V274.647ZM115.384 274.204L127.208 262.318L125.081 260.202L113.257 272.089L115.384 274.204ZM126.144 262.76H135.34V259.76H126.144V262.76ZM136.531 262.172L148.457 246.615L146.076 244.789L134.15 260.347L136.531 262.172ZM146.02 246.536L156.427 262.094L158.92 260.426L148.513 244.868L146.02 246.536ZM157.674 262.76H174.752V259.76H157.674V262.76ZM176.159 261.778L189.297 226.119L186.482 225.081L173.344 260.741L176.159 261.778ZM187.889 227.1H207.595V224.1H187.889V227.1ZM209.019 226.072L221.499 188.431L218.651 187.487L206.171 225.128L209.019 226.072ZM220.075 189.459H236.497V186.459H220.075V189.459ZM235.038 188.309L244.057 225.949L246.974 225.25L237.955 187.609L235.038 188.309ZM245.516 227.1H259.487V224.1H245.516V227.1ZM260.724 226.449L273.861 207.298L271.387 205.601L258.25 224.751L260.724 226.449ZM272.624 207.949H285.104V204.949H272.624V207.949ZM283.685 206.936L290.254 226.087L293.092 225.113L286.523 205.963L283.685 206.936ZM291.673 227.1H304.81V224.1H291.673V227.1ZM305.841 226.69L317.008 216.124L314.946 213.945L303.779 224.51L305.841 226.69ZM315.977 216.534H329.114V213.534H315.977V216.534Z",
    fill: "#FFAB57"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86.0759,
    y: 319.604,
    width: 40.5063,
    height: 3.37553,
    rx: 1.68776,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 86.0759,
    y: 149.141,
    width: 101.266,
    height: 6.75105,
    rx: 3.37553,
    fill: "#FDE78B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 86.0759,
    y: 164.33,
    width: 50.6329,
    height: 6.75105,
    rx: 3.37553,
    fill: "#FDE78B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 221.097,
    y: 319.604,
    width: 40.5063,
    height: 3.37553,
    rx: 1.68776,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 153.586,
    y: 319.604,
    width: 40.5063,
    height: 3.37553,
    rx: 1.68776,
    fill: "#FDE78B"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 288.608,
    y: 319.604,
    width: 40.5063,
    height: 3.37553,
    rx: 1.68776,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 140.084,
    y: 186.271,
    width: 1.68776,
    height: 113.08,
    rx: 0.843882,
    fill: "#EEE7FF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 308.861,
    y: 88.002,
    width: 81.0127,
    height: 81.0127,
    rx: 12,
    fill: "#2F2F2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M352.369 141.465H346.079C345.992 141.465 345.909 141.497 345.845 141.554C345.781 141.612 345.74 141.691 345.73 141.776C345.715 141.906 345.707 142.036 345.707 142.166C345.707 143.096 346.078 143.988 346.737 144.646C347.397 145.303 348.291 145.673 349.224 145.673C350.156 145.673 351.051 145.303 351.71 144.646C352.369 143.988 352.74 143.096 352.74 142.166C352.74 142.036 352.733 141.906 352.717 141.776C352.708 141.69 352.668 141.611 352.603 141.554C352.539 141.496 352.455 141.464 352.369 141.465Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M362.511 139.046C360.901 135.855 360.06 132.332 360.055 128.76V127.682C360.094 125.592 359.619 123.524 358.671 121.66C357.723 119.796 356.331 118.192 354.617 116.988C353.619 116.346 352.504 115.909 351.335 115.7V114.106C351.335 113.548 351.112 113.013 350.717 112.618C350.321 112.224 349.785 112.002 349.225 112.002C348.665 112.002 348.129 112.224 347.733 112.618C347.338 113.013 347.115 113.548 347.115 114.106V115.719C345.656 115.994 344.283 116.608 343.105 117.51C341.605 118.744 340.402 120.299 339.586 122.06C338.771 123.821 338.364 125.742 338.395 127.682V128.76C338.39 132.332 337.549 135.855 335.94 139.046C335.886 139.153 335.86 139.272 335.866 139.391C335.871 139.511 335.907 139.627 335.969 139.729C336.032 139.83 336.12 139.914 336.225 139.973C336.329 140.031 336.447 140.062 336.567 140.062H361.883C362.003 140.062 362.121 140.031 362.226 139.973C362.331 139.914 362.419 139.83 362.482 139.728C362.544 139.626 362.58 139.51 362.585 139.39C362.59 139.271 362.565 139.152 362.511 139.045V139.046Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 386.498,
    cy: 93.4435,
    r: 13.5021,
    fill: "#FFAB57"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M385.982 100.194H388.523V86.6914H386.617L383.122 89.1561L384.393 91.0849L385.982 90.0134V100.194Z",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 59,
    width: 180.278,
    height: 52.0084,
    rx: 11,
    stroke: "#FDE78B",
    strokeWidth: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 64.135,
    y: 78.2539,
    width: 91.1392,
    height: 3.37553,
    rx: 1.68776,
    fill: "#FDE78B"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 64.135,
    y: 88.3789,
    width: 65.8228,
    height: 3.37553,
    rx: 1.68776,
    fill: "#FDE78B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2113 93.1113C23.5791 92.4264 23.6218 91.3586 24.3067 90.7263L38.8517 77.3002C39.5366 76.6679 40.6044 76.7107 41.2367 77.3956C41.8689 78.0805 41.8262 79.1483 41.1413 79.7805L26.5963 93.2067C25.9113 93.8389 24.8436 93.7962 24.2113 93.1113Z",
    fill: "#FDE78B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9965 92.8867C39.0644 92.8867 38.3087 92.1311 38.3087 91.199L38.3087 80.2285L26.2834 80.2285C25.3513 80.2285 24.5957 79.4729 24.5957 78.5407C24.5957 77.6086 25.3513 76.853 26.2834 76.853L39.9965 76.853C40.9286 76.853 41.6843 77.6086 41.6843 78.5407L41.6843 91.199C41.6843 92.1311 40.9286 92.8867 39.9965 92.8867Z",
    fill: "#FDE78B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpportunitiesPremium);
export default __webpack_public_path__ + "static/media/opportunities-premium.35df548ed3ff077b508e60b93f38a2b4.svg";
export { ForwardRef as ReactComponent };